// extracted by mini-css-extract-plugin
export var active = "_m-8";
export var addWidgetButton = "_m-9";
export var backButton = "_m-1";
export var pageContainer = "_m-2";
export var settingsContent = "_m-0";
export var sideNavContainer = "_m-6";
export var sideNavLink = "_m-7";
export var widgetContainer = "_m-5";
export var widgetSubsectionItem = "_m-3";
export var widgetSubsectionItemContent = "_m-4";